import { render } from "./NcrmMailjetSenderDialog.vue?vue&type=template&id=28619acb&scoped=true"
import script from "./NcrmMailjetSenderDialog.vue?vue&type=script&lang=js"
export * from "./NcrmMailjetSenderDialog.vue?vue&type=script&lang=js"

import "./NcrmMailjetSenderDialog.vue?vue&type=style&index=0&id=28619acb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28619acb"]])

export default __exports__